import {afterNextRender, afterRender, Component, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {LogoComponent} from "../logo/logo.component";
import {SocialNetworksComponent} from "../../elements/social-networks/social-networks.component";
import {WP_REST_API_Menu_item} from "../../../models/Wordpress/WP_REST_API_Menu_item";
import {WordpressService} from "../../../services/wordpress.service";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {WP_REST_API_Attachment} from "wp-types";
import {RouterLink} from "@angular/router";
import {SwiperComponent, SwiperModule} from "swiper/angular";
import SwiperCore, {Autoplay, EffectFade, Lazy, Navigation, SwiperOptions} from "swiper";
SwiperCore.use([Autoplay,Lazy]);
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, LogoComponent, SocialNetworksComponent, MediaAttachmentComponent, AttachmentFromIdPipe, RouterLink, SwiperModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public navigation: WP_REST_API_Menu_item[][];
  public partners: any[];
  public othersPartners: any[];
  public othersPartnersCarroussel: any[];
  @ViewChild("partnersSlider") partnersSlider:SwiperComponent;
  partnersSliderConfig : SwiperOptions = {
    loop: true,
    modules: [Autoplay, Lazy],
    effect: 'slide',
    speed: 2000,
    autoplay : {
      delay : 4000,
      pauseOnMouseEnter : false,
      disableOnInteraction: false
    },
    pagination: false,
    navigation: false,
    slidesPerView : 4,
    spaceBetween: 20
  }
  constructor(public wp : WordpressService) {
    this.wp.getMenuItems('footer-menu').then((menu_items) => {
      this.navigation = menu_items ? this.splitArray(menu_items, 4) : [];
    });
    this.wp.getPartners().then((partners: {partners: any[],others_partners: any[],others_partners_carroussel: any[]})=>{
      this.partners = partners.partners;
      this.othersPartners = partners.others_partners;
      this.othersPartnersCarroussel = partners.others_partners_carroussel;
    });
  }

  splitArray(flatArray :any, numCols: number){
    const newArray = []
    for (let c = 0; c < numCols; c++) {
      newArray.push([])
    }
    for (let i = 0; i < flatArray.length; i++) {
      const mod = i % numCols;
      // @ts-ignore
      newArray[mod].push(flatArray[i])
    }
    return newArray
  }
}
